<div class="showing-box">
  <div class="showing-back" (click)="movePrev.emit()">
    <i class="fa fa-chevron-left"></i>
  </div>

  <div class="showing-date">
    {{ date$ | async }}
  </div>

  <div class="showing-next" (click)="moveNext.emit()">
    <i class="fa fa-chevron-right"></i>
  </div>
</div>

<div class="showing-options">
  <div class="today-pick">
    <a (click)="today()">Today</a>
  </div>
  <div class="picker">
    <luxon-calendar [styleIcon]="styleIconCalendar" [showInput]="false" [showIcon]="true" [showZone]="false" [zone]="timezone" [formControl]="selectedDate" appendTo="body"></luxon-calendar>
  </div>
</div>
